/* import __COLOCATED_TEMPLATE__ from './article-auto-reaction-leads.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();